// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: player.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { sdk_AudioFormatFromJSON, sdk_AudioFormatToJSON, Sdk_PlayOptions } from "./sdk";
export const protobufPackage = "taf";
export var Player_WexTeasableType;
(function (Player_WexTeasableType) {
    Player_WexTeasableType[Player_WexTeasableType["VOD_MOVIE_TEASABLE"] = 0] = "VOD_MOVIE_TEASABLE";
    Player_WexTeasableType[Player_WexTeasableType["VOD_EPISODE_TEASABLE"] = 1] = "VOD_EPISODE_TEASABLE";
    Player_WexTeasableType[Player_WexTeasableType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Player_WexTeasableType || (Player_WexTeasableType = {}));
export function player_WexTeasableTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "VOD_MOVIE_TEASABLE":
            return Player_WexTeasableType.VOD_MOVIE_TEASABLE;
        case 1:
        case "VOD_EPISODE_TEASABLE":
            return Player_WexTeasableType.VOD_EPISODE_TEASABLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Player_WexTeasableType.UNRECOGNIZED;
    }
}
export function player_WexTeasableTypeToJSON(object) {
    switch (object) {
        case Player_WexTeasableType.VOD_MOVIE_TEASABLE:
            return "VOD_MOVIE_TEASABLE";
        case Player_WexTeasableType.VOD_EPISODE_TEASABLE:
            return "VOD_EPISODE_TEASABLE";
        case Player_WexTeasableType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBasePlayer() {
    return {};
}
export const Player = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Player.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayer();
        return message;
    },
};
function createBasePlayer_CreateWex() {
    return { options: undefined };
}
export const Player_CreateWex = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.options !== undefined) {
            Player_CreateWex_PlayerOptions.encode(message.options, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_CreateWex();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.options = Player_CreateWex_PlayerOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { options: isSet(object.options) ? Player_CreateWex_PlayerOptions.fromJSON(object.options) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.options !== undefined) {
            obj.options = Player_CreateWex_PlayerOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Player_CreateWex.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_CreateWex();
        message.options = (object.options !== undefined && object.options !== null)
            ? Player_CreateWex_PlayerOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBasePlayer_CreateWex_PlayerOptions() {
    return {
        host: undefined,
        publicId: undefined,
        appVersion: undefined,
        appId: undefined,
        appName: undefined,
        license: undefined,
        licenseValidationUrl: undefined,
        stepBackwardDuration: undefined,
        stepForwardDuration: undefined,
    };
}
export const Player_CreateWex_PlayerOptions = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.host !== undefined) {
            writer.uint32(10).string(message.host);
        }
        if (message.publicId !== undefined) {
            writer.uint32(34).string(message.publicId);
        }
        if (message.appVersion !== undefined) {
            writer.uint32(42).string(message.appVersion);
        }
        if (message.appId !== undefined) {
            writer.uint32(48).uint32(message.appId);
        }
        if (message.appName !== undefined) {
            writer.uint32(82).string(message.appName);
        }
        if (message.license !== undefined) {
            writer.uint32(90).string(message.license);
        }
        if (message.licenseValidationUrl !== undefined) {
            writer.uint32(98).string(message.licenseValidationUrl);
        }
        if (message.stepBackwardDuration !== undefined) {
            writer.uint32(61).float(message.stepBackwardDuration);
        }
        if (message.stepForwardDuration !== undefined) {
            writer.uint32(69).float(message.stepForwardDuration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_CreateWex_PlayerOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.host = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.publicId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.appVersion = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.appId = reader.uint32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.appName = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.license = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.licenseValidationUrl = reader.string();
                    continue;
                case 7:
                    if (tag !== 61) {
                        break;
                    }
                    message.stepBackwardDuration = reader.float();
                    continue;
                case 8:
                    if (tag !== 69) {
                        break;
                    }
                    message.stepForwardDuration = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            host: isSet(object.host) ? globalThis.String(object.host) : undefined,
            publicId: isSet(object.publicId) ? globalThis.String(object.publicId) : undefined,
            appVersion: isSet(object.appVersion) ? globalThis.String(object.appVersion) : undefined,
            appId: isSet(object.appId) ? globalThis.Number(object.appId) : undefined,
            appName: isSet(object.appName) ? globalThis.String(object.appName) : undefined,
            license: isSet(object.license) ? globalThis.String(object.license) : undefined,
            licenseValidationUrl: isSet(object.licenseValidationUrl)
                ? globalThis.String(object.licenseValidationUrl)
                : undefined,
            stepBackwardDuration: isSet(object.stepBackwardDuration)
                ? globalThis.Number(object.stepBackwardDuration)
                : undefined,
            stepForwardDuration: isSet(object.stepForwardDuration)
                ? globalThis.Number(object.stepForwardDuration)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.host !== undefined) {
            obj.host = message.host;
        }
        if (message.publicId !== undefined) {
            obj.publicId = message.publicId;
        }
        if (message.appVersion !== undefined) {
            obj.appVersion = message.appVersion;
        }
        if (message.appId !== undefined) {
            obj.appId = Math.round(message.appId);
        }
        if (message.appName !== undefined) {
            obj.appName = message.appName;
        }
        if (message.license !== undefined) {
            obj.license = message.license;
        }
        if (message.licenseValidationUrl !== undefined) {
            obj.licenseValidationUrl = message.licenseValidationUrl;
        }
        if (message.stepBackwardDuration !== undefined) {
            obj.stepBackwardDuration = message.stepBackwardDuration;
        }
        if (message.stepForwardDuration !== undefined) {
            obj.stepForwardDuration = message.stepForwardDuration;
        }
        return obj;
    },
    create(base) {
        return Player_CreateWex_PlayerOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_CreateWex_PlayerOptions();
        message.host = object.host ?? undefined;
        message.publicId = object.publicId ?? undefined;
        message.appVersion = object.appVersion ?? undefined;
        message.appId = object.appId ?? undefined;
        message.appName = object.appName ?? undefined;
        message.license = object.license ?? undefined;
        message.licenseValidationUrl = object.licenseValidationUrl ?? undefined;
        message.stepBackwardDuration = object.stepBackwardDuration ?? undefined;
        message.stepForwardDuration = object.stepForwardDuration ?? undefined;
        return message;
    },
};
function createBasePlayer_WexPlayLive() {
    return {
        channelId: "",
        drmRequired: false,
        programStartEpochMs: 0,
        programEndEpochMs: 0,
        preferredAudioFormat: 0,
        pin: undefined,
        options: undefined,
    };
}
export const Player_WexPlayLive = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.channelId !== "") {
            writer.uint32(10).string(message.channelId);
        }
        if (message.drmRequired !== false) {
            writer.uint32(16).bool(message.drmRequired);
        }
        if (message.programStartEpochMs !== 0) {
            writer.uint32(24).uint32(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            writer.uint32(32).uint32(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            writer.uint32(40).int32(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            writer.uint32(50).string(message.pin);
        }
        if (message.options !== undefined) {
            Sdk_PlayOptions.encode(message.options, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexPlayLive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.drmRequired = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.programStartEpochMs = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.programEndEpochMs = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.preferredAudioFormat = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.pin = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.options = Sdk_PlayOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channelId: isSet(object.channelId) ? globalThis.String(object.channelId) : "",
            drmRequired: isSet(object.drmRequired) ? globalThis.Boolean(object.drmRequired) : false,
            programStartEpochMs: isSet(object.programStartEpochMs) ? globalThis.Number(object.programStartEpochMs) : 0,
            programEndEpochMs: isSet(object.programEndEpochMs) ? globalThis.Number(object.programEndEpochMs) : 0,
            preferredAudioFormat: isSet(object.preferredAudioFormat)
                ? sdk_AudioFormatFromJSON(object.preferredAudioFormat)
                : 0,
            pin: isSet(object.pin) ? globalThis.String(object.pin) : undefined,
            options: isSet(object.options) ? Sdk_PlayOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channelId !== "") {
            obj.channelId = message.channelId;
        }
        if (message.drmRequired !== false) {
            obj.drmRequired = message.drmRequired;
        }
        if (message.programStartEpochMs !== 0) {
            obj.programStartEpochMs = Math.round(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            obj.programEndEpochMs = Math.round(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            obj.preferredAudioFormat = sdk_AudioFormatToJSON(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            obj.pin = message.pin;
        }
        if (message.options !== undefined) {
            obj.options = Sdk_PlayOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Player_WexPlayLive.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_WexPlayLive();
        message.channelId = object.channelId ?? "";
        message.drmRequired = object.drmRequired ?? false;
        message.programStartEpochMs = object.programStartEpochMs ?? 0;
        message.programEndEpochMs = object.programEndEpochMs ?? 0;
        message.preferredAudioFormat = object.preferredAudioFormat ?? 0;
        message.pin = object.pin ?? undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? Sdk_PlayOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBasePlayer_WexPlayVod() {
    return {
        permissionToken: "",
        teasableType: 0,
        teasableId: "",
        drmRequired: false,
        programStartEpochMs: 0,
        programEndEpochMs: 0,
        preferredAudioFormat: 0,
        pin: undefined,
        options: undefined,
    };
}
export const Player_WexPlayVod = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.permissionToken !== "") {
            writer.uint32(10).string(message.permissionToken);
        }
        if (message.teasableType !== 0) {
            writer.uint32(16).int32(message.teasableType);
        }
        if (message.teasableId !== "") {
            writer.uint32(26).string(message.teasableId);
        }
        if (message.drmRequired !== false) {
            writer.uint32(32).bool(message.drmRequired);
        }
        if (message.programStartEpochMs !== 0) {
            writer.uint32(40).uint32(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            writer.uint32(48).uint32(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            writer.uint32(56).int32(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            writer.uint32(66).string(message.pin);
        }
        if (message.options !== undefined) {
            Sdk_PlayOptions.encode(message.options, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexPlayVod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.permissionToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.teasableType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.teasableId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.drmRequired = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.programStartEpochMs = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.programEndEpochMs = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.preferredAudioFormat = reader.int32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.pin = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.options = Sdk_PlayOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            permissionToken: isSet(object.permissionToken) ? globalThis.String(object.permissionToken) : "",
            teasableType: isSet(object.teasableType) ? player_WexTeasableTypeFromJSON(object.teasableType) : 0,
            teasableId: isSet(object.teasableId) ? globalThis.String(object.teasableId) : "",
            drmRequired: isSet(object.drmRequired) ? globalThis.Boolean(object.drmRequired) : false,
            programStartEpochMs: isSet(object.programStartEpochMs) ? globalThis.Number(object.programStartEpochMs) : 0,
            programEndEpochMs: isSet(object.programEndEpochMs) ? globalThis.Number(object.programEndEpochMs) : 0,
            preferredAudioFormat: isSet(object.preferredAudioFormat)
                ? sdk_AudioFormatFromJSON(object.preferredAudioFormat)
                : 0,
            pin: isSet(object.pin) ? globalThis.String(object.pin) : undefined,
            options: isSet(object.options) ? Sdk_PlayOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.permissionToken !== "") {
            obj.permissionToken = message.permissionToken;
        }
        if (message.teasableType !== 0) {
            obj.teasableType = player_WexTeasableTypeToJSON(message.teasableType);
        }
        if (message.teasableId !== "") {
            obj.teasableId = message.teasableId;
        }
        if (message.drmRequired !== false) {
            obj.drmRequired = message.drmRequired;
        }
        if (message.programStartEpochMs !== 0) {
            obj.programStartEpochMs = Math.round(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            obj.programEndEpochMs = Math.round(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            obj.preferredAudioFormat = sdk_AudioFormatToJSON(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            obj.pin = message.pin;
        }
        if (message.options !== undefined) {
            obj.options = Sdk_PlayOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Player_WexPlayVod.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_WexPlayVod();
        message.permissionToken = object.permissionToken ?? "";
        message.teasableType = object.teasableType ?? 0;
        message.teasableId = object.teasableId ?? "";
        message.drmRequired = object.drmRequired ?? false;
        message.programStartEpochMs = object.programStartEpochMs ?? 0;
        message.programEndEpochMs = object.programEndEpochMs ?? 0;
        message.preferredAudioFormat = object.preferredAudioFormat ?? 0;
        message.pin = object.pin ?? undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? Sdk_PlayOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBasePlayer_WexPlayRecording() {
    return {
        recordingId: 0,
        programId: 0,
        drmRequired: false,
        programStartEpochMs: 0,
        programEndEpochMs: 0,
        preferredAudioFormat: 0,
        pin: undefined,
        options: undefined,
    };
}
export const Player_WexPlayRecording = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.recordingId !== 0) {
            writer.uint32(8).uint32(message.recordingId);
        }
        if (message.programId !== 0) {
            writer.uint32(16).uint32(message.programId);
        }
        if (message.drmRequired !== false) {
            writer.uint32(24).bool(message.drmRequired);
        }
        if (message.programStartEpochMs !== 0) {
            writer.uint32(32).uint32(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            writer.uint32(40).uint32(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            writer.uint32(48).int32(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            writer.uint32(58).string(message.pin);
        }
        if (message.options !== undefined) {
            Sdk_PlayOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexPlayRecording();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.recordingId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.programId = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.drmRequired = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.programStartEpochMs = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.programEndEpochMs = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.preferredAudioFormat = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.pin = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.options = Sdk_PlayOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            recordingId: isSet(object.recordingId) ? globalThis.Number(object.recordingId) : 0,
            programId: isSet(object.programId) ? globalThis.Number(object.programId) : 0,
            drmRequired: isSet(object.drmRequired) ? globalThis.Boolean(object.drmRequired) : false,
            programStartEpochMs: isSet(object.programStartEpochMs) ? globalThis.Number(object.programStartEpochMs) : 0,
            programEndEpochMs: isSet(object.programEndEpochMs) ? globalThis.Number(object.programEndEpochMs) : 0,
            preferredAudioFormat: isSet(object.preferredAudioFormat)
                ? sdk_AudioFormatFromJSON(object.preferredAudioFormat)
                : 0,
            pin: isSet(object.pin) ? globalThis.String(object.pin) : undefined,
            options: isSet(object.options) ? Sdk_PlayOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.recordingId !== 0) {
            obj.recordingId = Math.round(message.recordingId);
        }
        if (message.programId !== 0) {
            obj.programId = Math.round(message.programId);
        }
        if (message.drmRequired !== false) {
            obj.drmRequired = message.drmRequired;
        }
        if (message.programStartEpochMs !== 0) {
            obj.programStartEpochMs = Math.round(message.programStartEpochMs);
        }
        if (message.programEndEpochMs !== 0) {
            obj.programEndEpochMs = Math.round(message.programEndEpochMs);
        }
        if (message.preferredAudioFormat !== 0) {
            obj.preferredAudioFormat = sdk_AudioFormatToJSON(message.preferredAudioFormat);
        }
        if (message.pin !== undefined) {
            obj.pin = message.pin;
        }
        if (message.options !== undefined) {
            obj.options = Sdk_PlayOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Player_WexPlayRecording.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_WexPlayRecording();
        message.recordingId = object.recordingId ?? 0;
        message.programId = object.programId ?? 0;
        message.drmRequired = object.drmRequired ?? false;
        message.programStartEpochMs = object.programStartEpochMs ?? 0;
        message.programEndEpochMs = object.programEndEpochMs ?? 0;
        message.preferredAudioFormat = object.preferredAudioFormat ?? 0;
        message.pin = object.pin ?? undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? Sdk_PlayOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBasePlayer_WexSetAudioTrack() {
    return { trackId: "" };
}
export const Player_WexSetAudioTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.trackId !== "") {
            writer.uint32(10).string(message.trackId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexSetAudioTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.trackId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { trackId: isSet(object.trackId) ? globalThis.String(object.trackId) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.trackId !== "") {
            obj.trackId = message.trackId;
        }
        return obj;
    },
    create(base) {
        return Player_WexSetAudioTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_WexSetAudioTrack();
        message.trackId = object.trackId ?? "";
        return message;
    },
};
function createBasePlayer_WexSeek() {
    return { seekSteps: 0 };
}
export const Player_WexSeek = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.seekSteps !== 0) {
            writer.uint32(8).int32(message.seekSteps);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexSeek();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.seekSteps = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { seekSteps: isSet(object.seekSteps) ? globalThis.Number(object.seekSteps) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.seekSteps !== 0) {
            obj.seekSteps = Math.round(message.seekSteps);
        }
        return obj;
    },
    create(base) {
        return Player_WexSeek.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlayer_WexSeek();
        message.seekSteps = object.seekSteps ?? 0;
        return message;
    },
};
function createBasePlayer_WexPlayPause() {
    return {};
}
export const Player_WexPlayPause = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexPlayPause();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Player_WexPlayPause.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayer_WexPlayPause();
        return message;
    },
};
function createBasePlayer_WexGetProperties() {
    return {};
}
export const Player_WexGetProperties = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayer_WexGetProperties();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Player_WexGetProperties.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlayer_WexGetProperties();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
